import { replace } from 'react-router-redux';

import { setWindowLocation } from 'js-utils/http';
import { trackEventFromState } from '@eb/site-analytics';

import {
    GA_AUTH_CATEGORY,
    GA_CONFIRMATION_ACKNOWLEDGED,
    GA_CONFIRMATION_REJECTED,
} from '../constants';

export const INITIALIZE_APP_ACTION = 'initializeApp';
export const initializeApp = (data) => ({
    type: INITIALIZE_APP_ACTION,
    payload: data,
});

// Signin Confirmation Actions
export const acknowledgeMessage = () => (dispatch, getState) => {
    trackEventFromState(getState(), {
        action: GA_CONFIRMATION_ACKNOWLEDGED,
        category: GA_AUTH_CATEGORY,
    });
    dispatch(replace('/signin'));
};

export const rejectMessage = (forwardURL) => (dispatch, getState) => {
    trackEventFromState(getState(), {
        action: GA_CONFIRMATION_REJECTED,
        category: GA_AUTH_CATEGORY,
    });
    setWindowLocation(forwardURL);
};
